import { render, staticRenderFns } from "./VNotificationList.vue?vue&type=template&id=7b6c6731"
import script from "./VNotificationList.vue?vue&type=script&lang=js"
export * from "./VNotificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports